<template lang="pug">
  .card-box.m-t-20
    .modal.bd-example-modal-lg(tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true")
      .modal-dialog.modal-dialog-centered.modal-xl
        CompareImageResourceModalContent(
          v-bind:intent="summary.intent"
          v-bind:preview="preview"
        )

    h4.text-dark.header-title.m-b-10
      | {{ tableTitle }}
      span.badge.badge-primary.m-l-5
        | {{resources.length}}

    template(v-if="resources.length == 0")
      div 該当する画像はありません。
    template(v-else)
      table.table.table-bordered
        thead
          tr
            th(width="20%")
            template(v-for="s in simulations")
              th(v-bind:width="tableCellWidth") {{ $t(`simulations.${summary.intent}.${s}`) }}
        tbody
          tr
            th.text-xl 全画像の合計
            td(v-for="(s, col) in simulations")
              div(v-if="col == 0")
                .text-xl.pull-left
                  Filesize(v-bind:value="sizes.orig")
              div(v-else)
                .text-xl.pull-left
                  Filesize(v-bind:value="reduces[s]" expectMinus)
                .text-xl.pull-right
                  Percentage(v-bind:value="reduceRates[s]" expectMinus)

          tr(v-for="(resource, idx) in imageResources")
            th
              div
                | 画像{{idx + 1}}
                = ' '
                ImageTypeBadge(v-bind:type="resource.ext")
              div
                small {{resource.hostname}}
            td.cell-bottom(v-for="(s, col) in simulations")
              template(v-if="imageResourceVisible(resource, s)")
                div(v-if="s == 'orig'")
                  a(v-bind:href="imageResourceUrl(resource, s)" target="_blank")
                    .m-b-10
                      img.img-fluid(v-bind:src="imageResourceUrl(resource, s)")
                div(v-else-if="hasOriginal(resource)")
                  a(href="javascript:void(0)" data-toggle="modal" data-target=".bd-example-modal-lg" v-on:click="selectPreviewResource(resource, s)")
                    .m-b-10.with-overlay-badge
                      span.badge.badge-secondary
                        i.mdi.mdi-magnify
                        | 比較
                      img.img-fluid(v-bind:src="imageResourceUrl(resource, s)")
                div(v-else)
                  a(v-bind:href="imageResourceUrl(resource, s)" target="_blank")
                    .m-b-10
                      img.img-fluid(v-bind:src="imageResourceUrl(resource, s)")
                div.d-flex.justify-content-between(v-if="col == 0")
                  strong
                    Filesize(v-bind:value="resource.data.orig.size")
                div.d-flex.justify-content-between(v-else)
                  strong
                    Filesize(v-bind:value="resourceReduced(resource, s)" expectMinus)
                  strong
                    Percentage(v-bind:value="resourceReducedRate(resource, s)" expectMinus)
</template>

<style lang="scss">
.with-overlay-badge {
  position: relative;
  display: inline-block;

  .badge {
    font-size: 13px;
    position: absolute;
    right: -25px;
    top: 5px;
  }
}
.modal-xl {
  max-width: 90%;
}
</style>

<script>
import Path from 'path'
import Lib from '@/lib'
import Filesize from '@/components/common/Filesize'
import Percentage from '@/components/common/Percentage'
import ImageTypeBadge from '@/components/common/ImageTypeBadge'
import CompareImageResourceModalContent from '@/components/CompareImageResourceModalContent'

export default {
  components: {
    Filesize,
    Percentage,
    ImageTypeBadge,
    CompareImageResourceModalContent,
  },
  data() {
    return {
      preview: {
        resource: null,
        simulation: null,
      },
    }
  },
  props: {
    tableTitle: String,
    s3KeyBase: String,
    summary: Object,
    resources: Array,
    simulations: {
      type: Array,
      default: () => ['orig'],
    },
  },
  computed: {
    tableCellWidth() {
      let w = Math.round(80 / this.simulations.length)
      return w + '%';
    },
    imageResources: function() {
      return this.resources.filter(r => r.data && r.data.orig);
    },
    sizes: function() {
      const sizes = this.imageResources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = (sizes[key] || 0);
          sizes[key] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reduces: function() {
      const sizes = this.sizes;
      const reduces = {};
      for (let key in sizes) {
        reduces[key] = sizes[key] - sizes.orig;
      }
      return reduces;
    },
    reduceRates: function() {
      const sizes = this.sizes;
      const reduces = this.reduces;
      const rates = {};
      for (let key in sizes) {
        rates[key] = reduces[key] / sizes.orig;
      }
      return rates;
    },
    sizesByExt: function() {
      const sizes = this.imageResources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = sizes[key] || {};
          sizes[key][r.ext] = sizes[key][r.ext] || 0;
          sizes[key][r.ext] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reducesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          reduces[key] = reduces[key] || {};
          reduces[key][ext] = sizes[key][ext] - sizes.orig[ext];
        }
      }
      return reduces;
    },
    reduceRatesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = this.reducesByExt;
      const rates = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          rates[key] = rates[key] || {};
          rates[key][ext] = reduces[key][ext] / sizes.orig[ext];
        }
      }
      return rates;
    },
    uniqueExts: function() {
      const unique = { jpg: 0, png: 0, gif: 0 };
      this.imageResources.forEach(r => unique[r.ext]++);
      return Object.keys(unique).filter(ext => unique[ext] > 0)
    },
  },
  methods: {
    hasOriginal(resource) {
      return resource.data && resource.data.orig && resource.data.orig.s3KeyPath
    },
    selectPreviewResource(resource, simulation) {
      this.preview.resource = resource
      this.preview.simulation = simulation
    },
    imageResourceVisible: function(resource, key) {
      return resource.s3KeyBase && resource.data[key] && resource.data[key].s3KeyPath;
    },
    imageResourceUrl: function(resource, key) {
      const uri = Path.join(resource.s3KeyBase, resource.data[key].s3KeyPath);
      const url = new URL(uri, Lib.preset().resourceUrlBase);
      return url.href;
    },
    resourceReduced: function(resource, key) {
      return resource.data[key].size - resource.data.orig.size;
    },
    resourceReducedRate: function(resource, key) {
      return (resource.data[key].size - resource.data.orig.size) / resource.data.orig.size;
    }
  },
}
</script>